"use client";
import React, { createContext, useContext, useState, useCallback } from "react";
import { CodeGenerationLoader } from "@/components/CodeGenerationLoader";

interface CodeGenerationLoadingContextType {
  showLoading: () => void;
  hideLoading: () => void;
  isLoading: boolean;
}

const CodeGenerationLoadingContext = createContext<
  CodeGenerationLoadingContextType | undefined
>(undefined);

export const useCodeGenerationLoading = () => {
  const context = useContext(CodeGenerationLoadingContext);
  if (!context) {
    throw new Error(
      "useCodeGenerationLoading must be used within CodeGenerationLoadingProvider"
    );
  }
  return context;
};

export const CodeGenerationLoadingProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const showLoading = useCallback(() => {
    setIsLoading(true);
  }, []);

  const hideLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  return (
    <CodeGenerationLoadingContext.Provider
      value={{ showLoading, hideLoading, isLoading }}
    >
      {children}
      <CodeGenerationLoader isVisible={isLoading} />
    </CodeGenerationLoadingContext.Provider>
  );
};

